(function () {
  function initTabs(root) {
    root.querySelectorAll('[data-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tab');
        root.querySelectorAll('[data-tab]').forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        root.querySelectorAll('[data-panel]').forEach(function (p) {
          p.classList.remove('is-active');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        var panel = root.querySelector('[data-panel="' + id + '"]');
        if (panel) {
          panel.classList.add('is-active');
          var track = panel.querySelector('[data-jhp-track]');
          if (track) track.scrollLeft = 0;
          panel.dispatchEvent(new CustomEvent('jhp:panel-active', { bubbles: true }));
        }
      });
    });
  }

  document.querySelectorAll('[data-jhp-shop]').forEach(initTabs);
})();
